import { getItem, hasLocalStorage, removeItem, setItem } from './localStorage';

export const localStorage = {
	hasLocalStorage,
	setItem,
	removeItem,
	getItem,
};
